import { authRequest } from './index.js'

export async function update_report_stats(report_id, report_meta_attributes){
  let data
  // console.log("🚀 ~ file: intervention.js:4 ~ update_report_stats ~ report_meta_attributes:", report_meta_attributes)
  // report_meta_attributes
  await authRequest.patch(
    '/report/intervention/' + report_id, 
    {report:{
      report_meta_attributes
    }}, 
    { headers: {
        'Content-Type': 'application/json'
      }
    }
  )
  .then(function(result){
    data = {result, error: false}
  })
  .catch(function (error){
    console.log(error)
    data = {error: true, result: error.response.data}
  })
  return data
}

export async function get_assessment(assessment_id){
  let data
  await authRequest.get(
    'assessments/' + assessment_id,
  )
  .then(function(result){
    data = {result: result.data, error: false}
  })
  .catch(function (error){
    console.log(error)
    data = {error: true, result: error.response.data}
  })
  return data
}

export async function get_trait_assessment(id){
  let data
  await authRequest.get(
    'traits/' + id.trait +
    '/childrens/' + id.child +
    '/assessments',
  )
  .then(function(result){
    data = {result: result.data, error: false}
  })
  .catch(function (error){
    console.log(error)
    data = {error: true, result: error.response.data}
  })
  return data
}

export async function create_assessment_progress(assessment_progress){
  let data
  await authRequest.post(
    '/assessment_progresses', 
    { assessment_progress }, 
    { headers: {
        'Content-Type': 'application/json'
      }
    }
  )
  .then(function(result){
    data = {result, error: false}
  })
  .catch(function (error){
    console.log(error)
    data = {error: true, result: error.response.data}
  })
  return data
}

export async function get_assessment_progress(assessment_id, child_id){
  let data
  await authRequest.get(
    'childrens/' + child_id +
    '/assessments/' + assessment_id +
    '/progress',
  )
  .then(function(result){
    data = {result: result.data, error: false}
  })
  .catch(function (error){
    console.log(error)
    data = {error: true, result: error.response.data}
  })
  return data
}

export async function get_assessment_history(trait_id, child_id){
  let data
  await authRequest.get(
    'childrens/' + child_id +
    '/traits/' + trait_id +
    '/assessments_history',
  )
  .then(function(result){
    data = {result: result.data, error: false}
  })
  .catch(function (error){
    console.log(error)
    data = {error: true, result: error.response.data}
  })
  return data
}